import { render, staticRenderFns } from "./RevisionClientTimeline.vue?vue&type=template&id=382fdd7c&scoped=true"
import script from "./RevisionClientTimeline.vue?vue&type=script&lang=js"
export * from "./RevisionClientTimeline.vue?vue&type=script&lang=js"
import style0 from "./RevisionClientTimeline.vue?vue&type=style&index=0&id=382fdd7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382fdd7c",
  null
  
)

export default component.exports